import { useDealContext } from "../../deal/context";
import Loading from "../../../components/Loading";
import { Outlet } from "react-router-dom/dist";
import { AdvisorSidebar } from "../components/AdvisorSidebar";
import { useAdvisor } from "../context/AdvisorContext";
import UnrecognizedUser from "../../../components/UncrecognizedUser";
import { useUserContext } from "../../users/context";
import { Button, Container, Dialog } from "@mui/material";
import { UserProfileUpdate } from "../../users/components/UserProfileUpdate";
import useAnalytics from "../../../hooks/useAnalytics";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Intercom from "@intercom/messenger-js-sdk";
import { AdvisorPreferenceForm } from "../components/AdvisorPreferenceForm";


export const Advisor = () => {
    const { dealContext } = useDealContext();
    const { advisor, loading, fetchAdvisor } = useAdvisor();
    const { userContext, loadUserContext } = useUserContext();
    const { trackPage } = useAnalytics();   
    const navigate = useNavigate();


    useEffect(() => {
        if (process.env.REACT_APP_INTERCOM_APP_ID && advisor) {
            Intercom({
                app_id: process.env.REACT_APP_INTERCOM_APP_ID,
                user_id: advisor?.user?.uuid ?? advisor?.uuid,
                name: advisor?.user?.profile?.name ?? advisor.name,
                email: advisor?.user?.email_address ?? advisor.email_address,
                created_at: (new Date(advisor.created_at)).valueOf(), // IMPORTANT: Replace "user.createdAt" with the variable you use to capture the user's sign-up date in a Unix timestamp (in seconds) e.g. 1704067200
            });
        } else {
            console.warn('Intercom is not configured');
        }
    }, [advisor]);

    useEffect(() => {
        if (advisor?.user?.profile?.user_reviewed) {
            const unratedMeetings = advisor.meetings?.filter((meeting: any) => 
                meeting.event_start
                && new Date(meeting.event_start) < new Date()
                && meeting.scheduler?.type !== "onboarding"
                && meeting.ratings?.length === 0
            );

            if (unratedMeetings?.length && unratedMeetings?.length > 0) {
                navigate(`/advisor/meet/${unratedMeetings[0].uuid}`);
            }
        }
    }, [advisor?.user?.profile?.user_reviewed]);

    if (!dealContext.fetched || loading) {
        return <Loading />;
    }

    if ((!loading && !advisor) || !advisor?.user) {
        trackPage("Advisor Not Found", {
            project_tag: dealContext.project.tag,
            advisor_id: advisor?.id,
            user_id: advisor?.user?.id,
            loading: loading,
        });
        return <UnrecognizedUser />;
    }

    if (advisor && dealContext.project.experience !== "advisor") {
        window.location.href = `${process.env.REACT_APP_APP_PROTOCOL ?? "https"}://app.${process.env.REACT_APP_APP_ORIGIN}/e/${advisor.survey_link.public_id}/expert/${advisor.public_id}`;
    }

    if (!advisor) {
        return <Loading />;
    }

    return (
        <>
            <aside className="page-sidebar">
                <AdvisorSidebar />
            </aside>
            <Container component="main">
                <Outlet />
            </Container>
            {advisor?.user?.profile && !advisor?.user?.profile?.user_reviewed &&
                <Dialog open={true} onClose={() => {}}>
                    <h5>Welcome to the {dealContext.project.name} Advisor Network</h5>
                    <p>Please take a moment to review and update your profile.</p>
                    <UserProfileUpdate user={advisor?.user} onUpdate={() => {
                        fetchAdvisor(dealContext.project.tag);
                    }} />
                </Dialog>
            }
            {advisor?.user?.profile && advisor?.user?.profile?.user_reviewed && advisor?.user?.open_to_advising === null &&
                <AdvisorPreferenceForm onClose={() => {
                    fetchAdvisor(dealContext.project.tag);
                    loadUserContext();
                }} />
            }
        </>
    );
};